import { jsx, css } from '@emotion/react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

// Components
import FormGroup from './oc-form-group';
import SelectDropdown from '../input-elements/oc-select-dropdown';
import TextInput from '../input-elements/oc-text-input';

const CityState = styled.div`
  ${props =>
    props.columns &&
    css`
      display: grid;
      grid-template-columns: 60% 1fr;
      gap: 32px;
    `}

  & > :first-child {
    margin-bottom: ${props => (props.columns ? '0' : '32px')};
  }
`;

const FormAddress = ({ columns, states, required = false }) => {
  const stateOptions = states || [
    'Alabama',
    'Alaska',
    'Arizona',
    'Arkansas',
    'California',
    'Colorado',
    'Connecticut',
    'Delaware',
    'Florida',
    'Georgia',
    'Hawaii',
    'Idaho',
    'Illinois',
    'Indiana',
    'Iowa',
    'Kansas',
    'Kentucky',
    'Louisiana',
    'Maine',
    'Maryland',
    'Massachusetts',
    'Michigan',
    'Minnesota',
    'Mississippi',
    'Missouri',
    'Montana',
    'Nebraska',
    'Nevada',
    'New Hampshire',
    'New Jersey',
    'New Mexico',
    'New York',
    'North Carolina',
    'North Dakota',
    'Ohio',
    'Oklahoma',
    'Oregon',
    'Pennsylvania',
    'Rhode Island',
    'South Carolina',
    'South Dakota',
    'Tennessee',
    'Texas',
    'Utah',
    'Vermont',
    'Virginia',
    'Washington',
    'West Virginia',
    'Wisconsin',
    'Wyoming',
  ];

  return (
    <FormGroup multipleFields columns={columns}>
      <div>
        <TextInput name="address1" label="Address 1" required={required} />
      </div>

      <div>
        <TextInput name="address2" label="Address 2" />
      </div>

      <CityState columns={columns}>
        <div>
          <TextInput name="city" label="City" required={required} />
        </div>
        <div>
          <SelectDropdown
            name="state"
            label="State"
            options={stateOptions}
            required={required}
          />
        </div>
      </CityState>

      <div>
        <TextInput name="postal-code" label="Postal Code" required={required} />
      </div>
    </FormGroup>
  );
};

export default FormAddress;

FormAddress.propTypes = {
  /** Set to true if you want a 2 column setup */
  columns: PropTypes.bool,
  /* HTML: Determines whether or not the fields are required */
  required: PropTypes.bool,
  /** Array of states for the state field */
  states: PropTypes.array,
};
